import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import InnerHTML from '@Components/InnerHTML';
import Button from '@Components/Button';

import './SynonymsList.scss';

function SynonymsList({ synonyms, limit, minHeight, separator, className, label }) {
  const selfRef = useRef();
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [synonyms]);

  const toggleExpanded = () => {
    const toggled = !expanded;
    const el = selfRef.current;

    if (el) {
      el.style.maxHeight = toggled ? `${Math.max(el.clientHeight, minHeight)}px` : '';
    }
    setExpanded(toggled);
  };

  const withShowMore = synonyms.length > limit;

  return (
    <div ref={selfRef} className={cn('synonyms-list', { 'synonyms-list--expanded': expanded }, className)}>
      {label}
      <InnerHTML html={(withShowMore && !expanded ? synonyms.slice(0, limit) : synonyms).join(separator)} />
      {withShowMore &&
        (expanded ? (
          <Button
            buttonConfig={{
              label: ' - show less',
              type: 'link',
              color: 'blue',
              size: 'xs',
              className: 'synonyms-list__show-more-button',
              e2eName: 'show-less',
            }}
            onClick={toggleExpanded}
          />
        ) : (
          <Button
            buttonConfig={{
              label: ` +${synonyms.length - limit} more`,
              type: 'link',
              color: 'blue',
              size: 'xs',
              className: 'synonyms-list__show-more-button',
              e2eName: 'show-more',
            }}
            onClick={toggleExpanded}
          />
        ))}
    </div>
  );
}

SynonymsList.defaultProps = {
  limit: 4,
  minHeight: 0,
  separator: ', ',
};

SynonymsList.propTypes = {
  synonyms: PropTypes.array.isRequired,
  limit: PropTypes.number,
  minHeight: PropTypes.number,
  separator: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.node,
};

export default SynonymsList;
